class YGScriptLoader extends HTMLElement {
  loadScript(url, fn) {
    if (url) {
      let loadScript = document.createElement('script')
      loadScript.src = url
      document.body.appendChild(loadScript)

      loadScript.onload = () => {
        fn()
      }

      loadScript.onerror = (err) => {
        console.error(err)
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const yg_mege_menus = document.querySelectorAll('.yg-mega-menu');
  
  function adjustMenuPosition(menu) {
    const menuRect = menu.getBoundingClientRect();
    const parentRect = menu.parentNode.getBoundingClientRect();
  
    let leftPos = parentRect.left - menuRect.width;
  
    if (leftPos < 0) {
      leftPos = 0;
    }
    else if (leftPos + menuRect.width > window.innerWidth) {
      leftPos = window.innerWidth - menuRect.width;
    }

    menu.style.left = `${leftPos}px`;
  }

  yg_mege_menus.forEach((item) => {
    adjustMenuPosition(item);
  })
})
